import { Button, ButtonProps, CircularProgress } from '@material-ui/core'

interface LoadingButtonProps extends ButtonProps {
  text: string
  loading: boolean
}

export function LoadingButton(props: LoadingButtonProps) {
  const { text, loading, ...btnProps } = props

  return (
    <Button {...btnProps}>
      {text}
      {loading && <CircularProgress size={16} style={{ marginRight: 8 }} />}
    </Button>
  )
}
